/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import React, {useEffect, useState} from 'react'
import 'semantic-ui-css/semantic.min.css';
import {
  Grid,
  Header,
  Segment,
  Image, Reveal, Icon
} from 'semantic-ui-react'
import styles from '../../components/Components.module.css'
import {NavLink} from 'react-router-dom';
import ResponsiveContainer from "../Common/ResponsiveContainer";

const MobileWidth = 768;

const HomePage = () => {

  const [hasRevealed, setHasRevealed] = useState(false);
  const handleReveal = () => {
    if (!hasRevealed) {
      setHasRevealed(true);
    }
  };
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resizeListener = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    }
  }, []);

  const mobile = screenWidth <= MobileWidth;

  return (
      <ResponsiveContainer style={{}}>
        <Segment
                 style={{
                   paddingTop: mobile ? '0em': '2em',
                   display: 'flex',
                   flexDirection: 'column'
                   }}
                 basic
                 vertical>
          <Grid container celled='internally' stackable
                style={{
                  paddingTop: mobile ? '0px' : '3em',
                  marginTop: mobile ? '0em' : '5em',
                }}>
            <Grid.Row centered style={{minHeight: '400px'}}>
              <Grid.Column width={7} style={{paddingBottom: '0px'}}>
              <Reveal
                  animated='fade'
                  onMouseOver={handleReveal}
                  disabled={mobile && hasRevealed}
                  style={{ pointerEvents: 'auto'}}
              >
                {!hasRevealed || !mobile ? (<Reveal.Content visible style={{
                  backgroundColor: 'var(--background)',
                  width: '100%',
                  height: '100%',
                  display: mobile ? 'flex' : 'inherit',
                  justifyContent: mobile ? 'center' : 'inherit',
                  flexDirection: mobile ? 'column' : 'inherit',
                  alignItems: mobile ? 'center' : 'inherit',
                  pointerEvents: 'none',
                }}>
                  <Image src={'/img/Auteursfoto.svg'} size={'medium'} style={{
                    paddingBottom: mobile ? '0px' : 'inherit'
                  }}/>
                </Reveal.Content>) : null }
                <Reveal.Content style={{
                  pointerEvents: 'auto',
                  display: mobile ? 'flex' : 'inherit',
                  justifyContent: mobile ? 'flex-end' : 'inherit',
                  flexDirection: mobile ? 'column' : 'inherit',
                  alignItems: mobile ? 'center' : 'inherit',
                }}>
                    <p
                       style={{
                         margin: mobile ? '0 auto' : 'inherit',
                         color: 'black',
                         maxWidth: mobile ? '80%' : '95%',
                         marginTop: mobile ? '0px' : '1em',
                         fontSize: '1.5em',
                         paddingBottom: '1em'
                    }}>
                      Ik ben Manouk van Egmond,
                      <span style={{fontWeight: 'bold'}}> schrijver</span>,
                      <span style={{fontWeight: 'bold'}}> journalist</span> en
                      <span style={{fontWeight: 'bold'}}> eindredacteur</span>, gespecialiseerd in humaninterestjournalistiek.
                      Mijn verhalen verschenen onder meer in <span style={{fontStyle: 'italic'}}>NRC, Het Parool, De Standaard, Vice </span> en <span style={{fontStyle: 'italic'}}>Hard/Hoofd</span>.
                      <br/><br/>
                      Sinds 2018 ben ik eindredacteur bij <span style={{fontStyle: 'italic'}}>NRC</span>,
                      en verricht ik redactiewerk voor een brede doelgroep.
                      Mijn debuut <span style={{fontStyle: 'italic'}}>Zelfs vogels zijn verlegen</span> verscheen in 2023 bij Mazirel Pers (Walburg Pers).
                      <br/><br/>
                      <NavLink to={"/achtergrond"}  style={{ pointerEvents: 'auto', cursor: 'pointer', color: 'var(--primary-col)', fontSize: '0.8em'}}>
                        Meer over mij<Icon name='arrow right' />
                      </NavLink>
                    </p>
                </Reveal.Content>
              </Reveal>
              </Grid.Column>
              <Grid.Column width={7}>
                <Grid container stackable style={{height: '100%'}}>
                  <Grid.Column floated={'right'} width={9}>
                    <Grid.Row style={{
                      minHeight: '33.33%',
                      display: 'flex',
                      justifyContent: screenWidth <= MobileWidth ? 'center' : 'flex-end',
                      alignItems: 'center'
                    }}>
                      <Header as={NavLink} to={'/boeken'} className={styles.homePageLink}>
                        Boeken
                      </Header>
                    </Grid.Row>
                    <Grid.Row style={{
                      minHeight: mobile ? '80px' : '33.33%',
                      display: 'flex',
                      justifyContent: screenWidth <= MobileWidth ? 'center' : 'flex-end',
                      alignItems: 'center'
                    }}>
                      <Header as={NavLink} to={'/stukken'} className={styles.homePageLink}>
                        Stukken
                      </Header>
                    </Grid.Row>
                    <Grid.Row style={{
                      minHeight: '33.33%',
                      display: 'flex',
                      justifyContent: screenWidth <= MobileWidth ? 'center' : 'flex-end',
                      alignItems: 'center'
                    }}>
                      <Header as={NavLink} to={'/eindredactie'} className={styles.homePageLink}>
                        Eindredactie
                      </Header>

                    </Grid.Row>
                  </Grid.Column>

                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>

      </ResponsiveContainer>
  );
}

export default HomePage
